export const POWERED_BY = 'Powered by';
